import { request } from './index'
import $store from '@/store/index'

export const queryProjectDecoder = data => {
  return request({
    url: '/media-hub/project/decoders',
    method: 'POST',
    data,
    notifyTitle: 'Get Decoders'
  })
}

export const getMHUserBehavior = (data) => {
  return request({
    url: `${$store.state.initConfig.mxServiceUrl}/mx-service/common/userBehavior`,
    method: 'GET',
    params: data,
    notifyTitle: 'Get User Behavior'
  })
}

export const setMHUserBehavior = (data) => {
  return request({
    url: `${$store.state.initConfig.mxServiceUrl}/mx-service/common/userBehavior`,
    method: 'POST',
    data,
    notifyTitle: 'Set User Behavior'
  })
}
